export function getUploadedVideoAudioCodec(metadata: {
  audioCodec?: string | null
  width: number | null
  height: number | null
  durationMs: number | null
}): string | null | undefined {
  return metadata.width && metadata.height && metadata.durationMs !== null
    ? (metadata.audioCodec ?? null)
    : undefined
}

export function getSavedVideoAudioCodec(
  details: { audio_codec?: string | null } | undefined,
): string | null | undefined {
  return details?.audio_codec
}
